import { create } from 'zustand';

interface SupportBoardState {
  loggedIn: boolean;
  setLoggedIn: (loggedIn: boolean) => void;
  supportLoaded: boolean;
  setSupportLoaded: (supportLoaded: boolean) => void;
  supportDiv: HTMLDivElement | undefined;
  setSupportDiv: (supportDiv: HTMLDivElement) => void;
  counterSpan: HTMLSpanElement | undefined;
  setCounterSpan: (counterSpan: HTMLSpanElement) => void;
  counter: string;
  setCounter: (counter: string) => void;
}

export const useSupportBoardState = create<SupportBoardState>((set) => ({
  loggedIn: false,
  setLoggedIn: (loggedIn: boolean) => set({ loggedIn }),
  supportLoaded: false,
  setSupportLoaded: (supportLoaded: boolean) => set({ supportLoaded }),
  supportDiv: undefined,
  setSupportDiv: (supportDiv: HTMLDivElement) => set({ supportDiv }),
  counterSpan: undefined,
  setCounterSpan: (counterSpan: HTMLSpanElement) => set({ counterSpan }),
  counter: '',
  setCounter: (counter: string) => set({ counter }),
}));
